import LogDetails from '@/components/app/LogDetails'
import SearchProtocol from '@/components/app/SearchProtocol'

const { getList } = require('@/api/base_entity')

const REFERENCE_PARENT_MAP = {
  pharmacy_id: 'pharmacy',
  provider_id: 'provider',
  storage_id: 'storage',
  disposal_id: 'disposal'
}

function getReferenceParentEntity (item) {
  const data = item?.response?.data ?? {}
  const parentField = Object.keys(REFERENCE_PARENT_MAP).find(field => data[field])
  return parentField ? REFERENCE_PARENT_MAP[parentField] : null
}

export default {
  'entity': 'log',
  'entityName': 'log',
  'pagination': {
    'rowsPerPage': 5,
    'page': 1,
    'sortBy': 'insert_at',
    'descending': true
  },  
  'sortBy': ['insert_at', 'desc'],
  'fields': [
    {
      value: 'insert_at',
      width: 100,
      text: 'Insert at',
      //issue 316 - modifica date da-a , aggiunto placeholderx
      filtertofrom: true,
      //issue 316 - modifica date da-a , aggiunto placeholderx
      'type': 'datetime',
      'table': {
        'sortable': true,
        'filter': true
      },
      render: item => {
        if (!item.insert_at) return ''
        const options = { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' };
        return new Date(item.insert_at).toLocaleString(undefined, options)
      },
    },
    {
      width: 120,
      value: '_account',
      text: 'Account',
      'type': 'text',
      'table': {
        'sortable': false,
        'filter': true
      },
      filter: (search) => [{ 'account.name': `%${search._account}%`}, {'account.surname' : `%${search._account}%`}],
      render: item => `${item?.account?.name ?? ''} ${item.account?.surname} (${item.account.role})`
    },
    {
      value: '_protocol',
      // type: 'search_autocomplete',
      text: 'Protocol',
      reference: 'protocol',
      title: 'name',
      list: (entity, search) => getList('protocol', { name: `%${search}%`}),
      //newlogs
      //render: item => (item?.response?.data?.protocol ?? item?.request?.protocol ?? item?.protocol)?.name,
      //filter: search => [{ response: `JSON(%${search._protocol}%,$.data.protocol_id)` }, { request: `JSON(%${search._protocol}%,$.protocol_id)` }],
      render: item => (item?.response?.data?.protocol ?? item?.protocol)?.name ?? '-',
      filter: (item, search) => [{ 'protocol_id': `${search}`} ],
      //newlogs
      table: {
        sortable: false,
        filter: true,
        searchComponent: SearchProtocol
      },
      width: 100
    },
    {
      width: 100,
      value: 'action',
      text: 'Action',
      table: true,
    },
    {
      value: 'section',
      text: 'Section',
      width: 100,
      table: {
        sortable: false,
        filter: true,
      },      
    },
    {
      width: 200,
      value: 'record',
      text: 'Details',
      table: {
        sortable: false,
        filter: false,
        component: LogDetails
      },
    },
    {

    }
  ],
  actions: [
    {
    entity: 'log',
    value: 'read',
    name: 'details',
    color: 'purple',
    text: 'Details',
    icon: 'mdi-arrow-right',
    disable: item =>  {
      if(['Auth', 'Storage', 'Pharmacy', 'Account', 'Provider', 'Disposal', 'Monitor', 'Reference', 'Provider codes', 'Protocol Site', 'Protocol Drugs'].includes(item.section)) return true
      if (!item.entity || !item.entity_id) return true
      if (item.entity === 'reference' && !getReferenceParentEntity(item)) return true
      return false
    },
    href: item => {
      const entityMap = {
        returned_has_drug: 'returned',
        fullyused_has_drug: 'fullyused',
        siteresponse_has_drug: 'siterequest',
        siterequest_has_drug: 'siterequest',
        patch_has_drug: 'patch',
        disposed_has_drug: 'disposed',
        request_has_drug: 'request',
        response_has_drug: 'request',
        protocol_has_site: 'protocol',
        report: 'protocol'
      }

      if (item.entity === 'reference') {
        const parentEntity = getReferenceParentEntity(item)
        return parentEntity ? `#/${parentEntity}` : undefined
      }

      const entity = entityMap[item.entity] ?? item.entity
      const entity_id = item?.response?.data?.[`${entity}_id`] ?? item?.request?.[`${entity}_id`] ?? item?.entity_id

      return `#/${entity}/${entity_id}`
    }
  },
  {
    entity: 'log',
    value: 'audit',
    name: 'audit',
    color: 'info',
    text: 'Audit',
    icon:'mdi-timeline-clock',
    disable: item =>  {
      if (['Auth', 'Monitor'].includes(item.section)) return true
      if (!item.entity || !item.entity_id) return true
      return false
    },
  },
]}
